var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.enabled)?_c('div',{staticClass:"upcoming-route"},[_c('h1',[_vm._v("My upcoming tickets")]),(_vm.loading)?_c('Loader'):(!_vm.upcoming)?_c('TixMessage',{attrs:{"type":"info","plain":"You have no upcoming tickets."}}):_c('EventsList',{attrs:{"sessions":_vm.upcoming}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }